<template>
  <v-dialog v-model="isOpen" scrollable max-width="1000px">
    <v-card>
      <v-card-title>
        <v-layout row wrap>
          <v-flex sm3 pr-1>
            <v-menu
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="queryParams.fromDate"
                label="From Date"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker v-model="queryParams.fromDate"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex sm3 pr-1>
            <v-menu
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="queryParams.toDate"
                label="To Date"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker v-model="queryParams.toDate"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex sm3 pr-1>
            <v-text-field
              name="issueNo"
              label="Issue No"
              type="text"
              v-model="queryParams.issueNo"
            ></v-text-field>
          </v-flex>
          <v-flex sm3 pr-1>
            <v-text-field
              name="referenceNo"
              label="Reference No"
              type="text"
              v-model="queryParams.referenceNo"
            ></v-text-field>
          </v-flex>
          <v-flex sm3>
            <v-select
              :items="typeList"
              label="Type"
              v-model="queryParams.type"
              item-text="label"
              item-value="value"
              menu-props="auto"
            ></v-select>
          </v-flex>
          <v-flex sm4>
            <v-btn outline color="primary" @click="onSearch">
              Search
              <v-icon right>search</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-card-text>
        <v-flex xs12>
          <v-data-table
            :headers="headers"
            :items="referenceNoList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            :must-sort="true"
          >
            <template slot="items" slot-scope="props">
              <td @click="add(props.item)">
                <a>{{ props.item.issueNo }}</a>
              </td>
              <td v-if="props.item.poNo != null">
                {{ props.item.poNo}}
              </td>
              <td v-else>
                {{ props.item.serialNo}}
              </td>
              <td>
                {{ props.item.issueDateInMilliSeconds | formatMsDate }}
              </td>
              <td>{{ props.item.shopName }}</td>
              <td>{{ props.item.description }}</td>
              <td>{{ props.item.status }}</td>
            </template>
          </v-data-table>
        </v-flex>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { emrService } from "../../services/emr-service";
import { productionOrderService } from "../../services/production-order-service";
import { storeReturnNoteService } from "../../services/store-return-note-service";
import { commonService } from "../../services/common-service";
import { LocationMovementDetail } from "../../models/model";

export default {
  name: "POAndEMRListDialog",
  props: {
    showDialog: Boolean,
    params: Object,
  },
  computed: {
    isOpen: {
      get() {
        return this.showDialog;
      },
      set() {
        this.dialogClose({});
      },
    },
  },
  data: () => ({
    showListLoading: false,
    queryParams: {
      fromDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      toDate: commonService.formatDate(new Date(), "YYYY-MM-DD"),
      issueNo: "",
      type: "PRODUCTION_ORDER",
      status: "CONFIRM",
      binId: "",
      warehouseId: "",
      referenceNo: "",
      isAddDetails: false,
      isAddUnits: false,
      checkLocationMovement: true,
    },
    headers: [
      { text: "Issue No", value: "issueNo", sortable: false },
      { text: "Reference No ", value: "referenceNo", sortable: false },
      {
        text: "Issue Date",
        align: "left",
        value: "issueDate",
        sortable: false,
      },
      { text: "Shop", value: "shop.name", sortable: false },
      { text: "Description", value: "description", sortable: false },
      { text: "Status", value: "status", sortable: false },
    ],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "updatedDate",
      totalItems: 0,
    },
    typeList: [
      { label: "PRODUCTION_ORDER", value: "PRODUCTION_ORDER" },
      { label: "EMR", value: "EMR" },
      { label: "RMR", value: "RMR" },
      { label: "STORE_RETURN_NOTE", value: "STORE_RETURN_NOTE" },
    ],
    rowsPerPageItems: [25, 50, 100],
    totalRows: 0,
    currentType: "PRODUCTION_ORDER",
    referenceNoList: [],
    locationMovementDetailList: [],
  }),
  watch: {
    isOpen: {
      handler() {
        if (this.isOpen) {
          this.queryParams = {
            ...this.params,
          };
          this.queryParams.type = "PRODUCTION_ORDER";
          this.referenceNoList = [];
          this.locationMovementDetailList = [];
          this.currentType = "";
          this.getProductionOrderList();
        }
      },
    },
  },
  methods: {
    onSearch() {
      this.referenceNoList = [];
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      if (this.queryParams.type == "PRODUCTION_ORDER") {
        this.getProductionOrderList();
      } else if (
        this.queryParams.type == "EMR" ||
        this.queryParams.type == "RMR"
      ) {
        this.getEMRList();
      } else if (this.queryParams.type == "STORE_RETURN_NOTE") {
        this.getStoreReturnNoteList();
      }
    },
    getProductionOrderList() {
      this.showListLoading = true;
      this.queryParams.isAddDetails = false;
      this.queryParams.isAddUnits = false;
      this.queryParams.checkLocationMovement = true;
      this.queryParams.poNo = this.queryParams.referenceNo;
      let order = this.pagination.descending ? "desc" : "asc";
      productionOrderService
        .getProductionOrderList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.referenceNoList = res.data.productionOrderList;
            this.totalRows = res.data.totalElements;
            this.currentType = "PRODUCTION_ORDER";
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    getEMRList() {
      if (this.queryParams.type == "EMR" || this.queryParams.type == "RMR") {
        this.showListLoading = true;
        let order = this.pagination.descending ? "desc" : "asc";
        this.queryParams.isAddDetails = false;
        this.queryParams.isAddUnits = "";
        this.queryParams.checkLocationMovement = true;
        this.queryParams.serialNo = this.queryParams.referenceNo;
        emrService
          .getEMRList(
            this.queryParams,
            this.pagination.page,
            this.pagination.rowsPerPage,
            this.pagination.sortBy + "," + order
          )
          .then((res) => {
            console.log(res.data);
            if (res.data) {
              this.referenceNoList = res.data.emrList;
              this.totalRows = res.data.totalElements;
              this.currentType = this.queryParams.type;
            }
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            this.showListLoading = false;
          });
      }
    },
    getStoreReturnNoteList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      this.queryParams.isAddDetails = false;
      this.queryParams.isAddUnits = "";
      this.queryParams.checkLocationMovement = true;
      this.queryParams.serialNo = this.queryParams.referenceNo;
      storeReturnNoteService
        .getStoreReturnNoteList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.referenceNoList = res.data.storeReturnNoteList;
            this.totalRows = res.data.totalElements;
            this.currentType = "STORE_RETURN_NOTE";
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    getBatchDate(locationMovementDetail) {
      locationMovementDetail.mfgDate = "";
      locationMovementDetail.expDate = "";
      let batchNo = locationMovementDetail.batchNoList.find(
        (v) => v.batchNo == locationMovementDetail.batchNo
      );
      if (batchNo) {
        let batchDate = batchNo.qcBatchDateDTOList.find(
          (v) => v.batchNo == locationMovementDetail.batchNo
        );
        if (batchDate) {
          locationMovementDetail.mfgDate = batchDate.mfgDate;
          locationMovementDetail.expDate = batchDate.expDate;
        }
      }
    },
    add(referenceNoObj) {
      this.locationMovementDetailList = [];
      let referenceObj = {};
      if (this.currentType == "PRODUCTION_ORDER") {
        referenceNoObj.productionOrderDetailList.forEach((item) => {
          let locationMovementDetail = new LocationMovementDetail();
          locationMovementDetail.productId = item.itemProductId;
          locationMovementDetail.productCode = item.itemProductCode;
          locationMovementDetail.productName = item.itemProductName;
          locationMovementDetail.productUnitId = item.productUnitId;
          locationMovementDetail.factorUnitName = item.factorUnitName;
          locationMovementDetail.productUnits = item.productUnits;
          locationMovementDetail.qcNo = item.qcNo;
          locationMovementDetail.batchNo = "";
          locationMovementDetail.stockQcNoDTOList = item.stockQcNoDTOList;
          locationMovementDetail.batchNoList = item.batchNoList;
          this.getBatchDate(locationMovementDetail);
          locationMovementDetail.qty = item.itemQty;
          locationMovementDetail.remark = "";
          this.locationMovementDetailList.push(locationMovementDetail);
        });
        referenceObj = {
          issueNo: referenceNoObj.issueNo,
          referenceNo: referenceNoObj.poNo,
          locationMovementDetailList: this.locationMovementDetailList,
        };
      } else if (this.currentType == "EMR" || this.currentType == "RMR") {
        referenceNoObj.emrDetailList.forEach((item) => {
          let locationMovementDetail = new LocationMovementDetail();
          locationMovementDetail.productId = item.productId;
          locationMovementDetail.productCode = item.productCode;
          locationMovementDetail.productName = item.productName;
          locationMovementDetail.productUnitId = item.productUnitId;
          locationMovementDetail.factorUnitName = item.factorUnitName;
          locationMovementDetail.productUnits = item.productUnits;
          locationMovementDetail.qcNo = "";
          locationMovementDetail.batchNo = "";
          locationMovementDetail.stockQcNoDTOList = item.stockQcNoDTOList;
          locationMovementDetail.batchNoList = item.batchNoList;
          this.getBatchDate(locationMovementDetail);
          locationMovementDetail.qty = item.qty;
          locationMovementDetail.remark = "";
          this.locationMovementDetailList.push(locationMovementDetail);
        });
        referenceObj = {
          issueNo: referenceNoObj.issueNo,
          referenceNo: referenceNoObj.serialNo,
          locationMovementDetailList: this.locationMovementDetailList,
        };
      } else if (this.currentType == "STORE_RETURN_NOTE") {
        referenceNoObj.storeReturnNoteDetailList.forEach((item) => {
          let locationMovementDetail = new LocationMovementDetail();
          locationMovementDetail.productId = item.productId;
          locationMovementDetail.productCode = item.productCode;
          locationMovementDetail.productName = item.productName;
          locationMovementDetail.productUnitId = item.productUnitId;
          locationMovementDetail.factorUnitName = item.factorUnitName;
          locationMovementDetail.productUnits = item.productUnits;
          locationMovementDetail.qcNo = "";
          locationMovementDetail.batchNo = "";
          locationMovementDetail.stockQcNoDTOList = item.stockQcNoDTOList;
          locationMovementDetail.batchNoList = item.batchNoList;
          locationMovementDetail.qty = item.qty;
          locationMovementDetail.remark = "";
          this.locationMovementDetailList.push(locationMovementDetail);
        });
        referenceObj = {
          issueNo: referenceNoObj.issueNo,
          referenceNo: referenceNoObj.serialNo,
          locationMovementDetailList: this.locationMovementDetailList,
        };
      }
      this.dialogClose(referenceObj);
    },
    dialogClose(obj) {
      this.$emit("close", obj);
    },
  },
};
</script>
